module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAP1BMVEUAkkbOKzf////OKzfy+vb99PUNl0/QNkEAizrLHSoAkkbOKzf///8AkkbOKzfy+vb99PUNl0/QNkEAizrLHSqV7mp5AAAADHRSTlPy8vL+8vLy8vLy5uYzZhtxAAAAYElEQVRYw+3Ytw0AMRADwdN77/uv9RtgyECCdgsYKBKBiyVU09A1sn6ck2qNXfbe5ya7nu+QRXigBAQEBARUI2Sao9a2a9m9CAgICAiopM8/v6UFAgICAioHcu2a7Xz4A8SSAvJ4iBodAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/buttonCulture/it.png
// module id = 451
// module chunks = 0